/*
 *   File : search-input.js
 *   Author : https://evoqins.com
 *   Description : search input component
 *   Integrations : NA
 *   Version : 1.0.0
 */

import React, { memo } from "react";

import { PrimaryButton } from "../Buttons";
import Icon from "../icons";

const CustomSearchInput = (props) => {
  //input handle change
  const _handleChange = (e) => {
    let value = e.target.value;
    props.handleChange(value);
  };

  //Handle clear
  const _handleClear = () => {
    props.handleChange("");
  };

  const submitSearch = (value) => {
    if (typeof props.onKeyPress === "function") {
      props.onKeyPress(value ?? props.value);
    }
  };

  const keyPress = (e) => {
    if (e.key === "Enter") {
      if (props.onEnter) {
        submitSearch(e.target.value);
      } else if (typeof props.onKeyPress === "function") {
        props.onKeyPress();
      }
    }
  };

  return (
    <div className="w-100 flex-grow-1">
      {props.label && (
        <label
          className={`${props.labelStyle} text-eerie-black  fw-500 fs-14 pb-2`}
        >
          {props.label}
        </label>
      )}

      <div className={`rounded-pill position-relative overflow-hidden`}>
        <Icon icon={"search"} size={12} className="e-search-icon" />
        <input
          id={props.id}
          ref={props.ref}
          value={props.value}
          defaultValue={props.defaultValue}
          maxLength={props.maxLength}
          tabIndex={props.tabIndex}
          type={props.type}
          required={props.required}
          readOnly={props.readOnly}
          autoFocus={props.autoFocus}
          placeholder={props.placeholder}
          className={` e-search-input ${props.className} rounded-pill py-10 fs-14 text-black fw-400`}
          onWheel={() => document.activeElement.blur()}
          onChange={_handleChange}
          onKeyDown={(e) => keyPress(e)}
          onClick={props.onClick}
        />

        {props.value && (
          <div className="d-flex e-search-button-grp h-100">
            <PrimaryButton
              icon="close"
              ClassName="p-1 bg-transparent"
              onPress={_handleClear}
              size="12px"
            />
            <PrimaryButton
              icon="arrow-right"
              ClassName="px-2 py-1 bg-facebook-blue rounded-0"
              onPress={() => {
                if (props.onEnter) {
                  submitSearch(props.value);
                } else {
                  keyPress({ key: "Enter" });
                }
              }}
              size="12px"
            />
          </div>
        )}
      </div>
    </div>
  );
};

CustomSearchInput.defaultProps = {
  onEnter: false,
  onKeyPress: () => {},
  className: null,
  error: "",
};

export default memo(CustomSearchInput);
